<template>
    <v-container>
      <v-form
        ref="organizationForm"
        lazy-validation>
        <v-row justify="space-around">
            <v-col cols="24" md="11" align="right" v-if="authType === 'DB'">
                <v-icon
                @click="addNew" color="#2b5d66">control_point</v-icon> <span  @click="addNew" style="cursor:pointer;color:#2b5d66;">{{ $t('newOrganization') }}</span>
           
            </v-col>
        </v-row>
        <v-row justify="space-around">
            <v-col cols="24" md="11" align="right">
            </v-col>
        </v-row>
        <v-row justify="space-around" >
            <v-col cols="6" md="5">
                <v-text-field
                v-model.trim="organization.name"
                :rules="[v => !!v || '!']"
                v-bind:label="$t('organizationName')">
                </v-text-field>
                <v-text-field
                v-model.trim="organization.street"
                :rules="[v => !!v || '!']"
                v-bind:label="$t('address')">
                </v-text-field>
                <v-text-field
                v-model.trim="organization.postalZone"
                :rules="[v => !!v || '!', v => /^\d*$/.test(v) || 'Broj']"
                v-bind:label="$t('postalZone')">
                </v-text-field>
                <v-text-field
                v-model.trim="organization.city"
                :rules="[v => !!v || '!']"
                v-bind:label="$t('city')">
                </v-text-field>
                <v-text-field
                v-model.trim="organization.country"
                :rules="[v => !!v || '!']"
                v-bind:label="$t('country')">
                </v-text-field>
            </v-col>
            <v-col cols="6" md="5">
                <v-text-field
                v-model.trim="organization.mb"
                :rules="[v => !!v || '!', v => /^\d*$/.test(v) || 'Broj', v => (v.length == 8 || v.length == 13) || 'Mora imati 8 cifara']"
                v-bind:label="$t('mbNumber')">
                </v-text-field>
                <v-text-field
                v-model.trim="organization.pib"
                v-bind:label="$t('pib')"
                :rules="[v => !!v || '!', v => /^\d*$/.test(v) || 'Broj', v => v.length == 9 || 'Mora imati 9 cifara']">
                </v-text-field>
                <v-text-field
                v-model.trim="organization.account"
                :rules="[v => !!v || '!', v => /^\d*$/.test(v) || 'Broj', v => v.length == 18 || 'Mora imati 18 cifara']"
                v-bind:label="$t('account')">
                </v-text-field>
                <v-text-field
                v-model.trim="organization.email"
                :rules="[v => !!v || '!', v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+(,\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+)*$/.test(v) || 'Email adresa nije validna']"
                v-bind:label="$t('email')">
                </v-text-field>
                <v-text-field
                v-model.trim="organization.apiKey"
                :rules="[v => !!v || '!']"
                v-bind:label="$t('apikey')">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row justify="space-around">
            <v-col cols="8" md="5">
            </v-col>
            <v-col cols="4" md="5" align="right">
                <v-btn 
                class="mx-2"
                :dark="hasChanged"
                :disabled="!hasChanged"
                color="#2b5d66"
                @click="save">
                {{ $t('save') }}
                </v-btn>
                <v-btn 
                class="mx-2"
                :dark="hasChanged"
                :disabled="!hasChanged"
                color="#2b5d66"
                @click="cancel">
                {{ $t('cancel')}}
                </v-btn>
            </v-col>
          </v-row>
      </v-form>
    </v-container>
</template>

<script>
    export default {
        name: "Organization",
        components: {
        },
        data() {
            return {
                initialOrganization: {
                    organizationId: -1,
                    name: "",
                    mb: "",
                    pib: "",
                    street: "",
                    postalZone: "",
                    city: "",
                    country: "", 
                    account: "",
                    apiKey: "",
                    email: ""
                },
                organization: {
                    organizationId: -1,
                    name: "",
                    mb: "",
                    pib: "",
                    street: "",
                    postalZone: "",
                    city: "",
                    country: "", 
                    account: "",
                    apiKey: "",
                    email: ""
                }
            }
        },
        created() {
            this.getOrganizationDetails()
        },
        computed: {
            selectedOrganization() {
                return this.$store.getters.organizationId;
            },
            hasChanged () {
                return JSON.stringify(this.organization) !== JSON.stringify(this.initialOrganization);
            },
            loggedUser() {
                return this.$store.getters.loggedUser;
            },
            authType() {
                return this.$config.AuthConfigType;
            }
        },
        methods: {
            getOrganizationDetails() {
                this.axios.get('Organization/OrganizationDetails?organizationid=' + this.selectedOrganization).then((response) => {  
                    this.initialOrganization = response.data;  
                    this.organization = JSON.parse(JSON.stringify(this.initialOrganization))
                })
                .catch(err => console.log(err)); 
            },
            validation() {
                return this.$refs.organizationForm.validate()
            },
            save() {
                if(this.validation()) {
                    var formData = new FormData()
                    
                    formData.append('organizatioDetailsJson', JSON.stringify(this.organization))

                    this.axios.post('Organization/SaveOrganizationDetails', formData)
                    .then(response => {
                        this.initialOrganization = response.data;  
                        this.organization = JSON.parse(JSON.stringify(this.initialOrganization))
                        this.$store.dispatch('getUsersPermissions', this.loggedUser)
                        .then(() => {
                            this.$store.dispatch('organizationChange', this.organization.organizationId)
                            .then(() => {
                            this.navigationKey += 1 //reload navigation drawer
                            if(this.$route.name != "Home")
                                this.$router.push('/')
                            })
                        })
                        .catch(err => {
                            this.message = err
                            console.log(err)
                        })

                        this.$root.displayNotificationMsg(this.$t('saved'), 'success')
                    })
                    .catch(err => console.log(err));
                }
                else {
                    this.$root.displayNotificationMsg(this.$t('dataRequired'), 'warning')
                }
            },
            async cancel() {
                if(this.hasChanged && await this.$confirm(this.$t('saveChangesMessage'), { title: this.$t('warning'), buttonTrueText: this.$t('yes'), buttonFalseText: this.$t('no'), persistent: true }))
                    this.organization = JSON.parse(JSON.stringify(this.initialOrganization))
            },    
            addNew() {
                this.$refs.organizationForm.reset()
                this.organization.organizationId = -1
            }                      
        }
    }
</script>